import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { getIso6523IcdOptions } from '../../api/codelist/codeListsSlice';

const PartyIdentificationSchemeSelect = ({
  name,
  label = 'Party Identification Scheme',
  control,
  errors,
  readOnly = false,
  disabled,
  onChange,
}) => {
  const iso6523IcdOptions = useSelector(getIso6523IcdOptions);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <Autocomplete
            {...field}
            id={name}
            data-testid={`${name}-select`}
            options={iso6523IcdOptions}
            readOnly={readOnly}
            getOptionLabel={(option) =>
              option.label ? (option.code ? `${option.label} (${option.code})` : option.label) : ''
            }
            renderInput={(params) => (
              <TextField
                {...params}
                data-testid={`${name}-input`}
                label={label}
                error={!!get(errors, name, null)}
                helperText={get(errors, name, {})?.message}
              />
            )}
            isOptionEqualToValue={(option, value) => option.code === value?.code}
            onChange={(_, value) => {
              field.onChange(value);
              onChange?.(value);
            }}
            value={field.value || null}
            disabled={disabled}
          />
        );
      }}
    />
  );
};

export default PartyIdentificationSchemeSelect;
